import { render, staticRenderFns } from "./softUpdate.vue?vue&type=template&id=6d260e08&scoped=true"
import script from "./softUpdate.vue?vue&type=script&lang=js"
export * from "./softUpdate.vue?vue&type=script&lang=js"
import style0 from "./softUpdate.vue?vue&type=style&index=0&id=6d260e08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d260e08",
  null
  
)

export default component.exports